/**
 * Presentations is a private, internal sales tool — NOT a general feature.
 * Only the accounts in this allowlist may see/use the `/presentations` admin
 * area (nav item + routes). The public token-gated viewer (`/p/:token`) is
 * unaffected — anyone with a published deck's link can view it.
 */
export const PRESENTATIONS_ALLOWED_EMAILS = ['post@davidbakke.no']

export function canUsePresentations(email: string | null | undefined): boolean {
  return !!email && PRESENTATIONS_ALLOWED_EMAILS.includes(email.trim().toLowerCase())
}
